import { render, staticRenderFns } from "./wrathOfEgypt.vue?vue&type=template&id=51149e94&scoped=true"
import script from "./wrathOfEgypt.vue?vue&type=script&lang=js"
export * from "./wrathOfEgypt.vue?vue&type=script&lang=js"
import style0 from "./wrathOfEgypt.vue?vue&type=style&index=0&id=51149e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51149e94",
  null
  
)

export default component.exports